module.exports = __webpack_public_path__ + "static/media/clooger-1.dcaa66e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cases/clooger-1.jpg
// module id = 370
// module chunks = 0